import { useContext } from 'react';
import { AppGlobalContext, AppGlobalUpdateContext } from '../context';
export function useAppContext(prop = null, initialValue = {}) {
    const appContext = useContext(AppGlobalContext);
    const setAppContext = useContext(AppGlobalUpdateContext);
    // if we are requesting a certain property of app context, return just that property.
    if (prop) {
        const contextProperty = appContext[prop]
            ? appContext[prop]
            : initialValue;
        const setContextProperty = (value) => setAppContext({ ...appContext, [prop]: value });
        return [contextProperty, setContextProperty];
    }
    else {
        return [appContext, setAppContext];
    }
}
